import { MarkdownView } from 'components/MarkdownView'
import { useCurrentProving } from 'hooks/useCurrentProving'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Page, Section } from './Layout'

export const PageSpecialNote: React.FC = () => {
  const { t } = useTranslation()
  const [proving] = useCurrentProving()

  return (
    <Page>
      <Section label={t('section.specialNote.header')}>
        {proving.provingGround!.specialNote &&
        proving.provingGround!.specialNote !== '' ? (
          <MarkdownView markdown={proving.provingGround!.specialNote} />
        ) : (
          t('emptySpecialNote')
        )}
      </Section>

      {/* <Section label={t('section.debug.header')}>
        <pre>{JSON.stringify(proving.provingGround, null, 2)}</pre>
      </Section> */}
    </Page>
  )
}
